"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuditLogDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class AuditLogDto {}
exports.AuditLogDto = AuditLogDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AuditLogDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AuditLogEventType
}), __metadata("design:type", String)], AuditLogDto.prototype, "eventType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AuditLogProducer
}), __metadata("design:type", String)], AuditLogDto.prototype, "producer", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], AuditLogDto.prototype, "performedByPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], AuditLogDto.prototype, "performedByFullName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AuditLogDto.prototype, "affectedUserPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AuditLogDto.prototype, "affectedUserFullName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], AuditLogDto.prototype, "comment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: 'object'
}), __metadata("design:type", Object)], AuditLogDto.prototype, "data", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AuditLogDto.prototype, "createdAt", void 0);
//# sourceMappingURL=AuditLog.dto.js.map